import { META_HEADER_TITLE, META_ALLOW_ANONYMOUS } from "@core/constants";
import { FUNNEL_SIGNUP_MAIN, META_PROGRESS } from "@etab/config";
import { DataLayerManager } from "@core/managers/datalayer-manager";
import { StorageManager } from "@core/managers/storage.manager";

import AddressStep from "./Address.step.vue";
import CategoryStep from "./Category.step.vue";
import CheckStep from "./Check.vue";
import FamilyStep from "./Family.step.vue";
import IdentityStep from "./Identity.step.vue";
import NameStep from "./Name.step.vue";
import PasswordStep from "./Password.step.vue";
import PhoneStep from "./Phone.step.vue";
import OriginStep from "./Origin.step.vue";
import EmployeesStep from "./Employees.step.vue";

export const accountFirstStep = FUNNEL_SIGNUP_MAIN.name;

export const getAccountSteps = () => {
  return [
    {
      path: FUNNEL_SIGNUP_MAIN.name,
      name: FUNNEL_SIGNUP_MAIN.name,
      meta: {
        [META_ALLOW_ANONYMOUS]: true,
        [META_PROGRESS]: 1,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.MAIN.NAME.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        DataLayerManager.setData(
          { page_type: "formulaire", user_connect: "no", formulaire: "signup", formulaire_step_number: "1" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next();
      },
      component: NameStep,
    },
    {
      path: FUNNEL_SIGNUP_MAIN.address,
      name: FUNNEL_SIGNUP_MAIN.address,
      meta: {
        [META_ALLOW_ANONYMOUS]: true,
        [META_PROGRESS]: 2,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.MAIN.ADDRESS.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        DataLayerManager.setData(
          { page_type: "formulaire", user_connect: "no", formulaire: "signup", formulaire_step_number: "2" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next();
      },
      component: AddressStep,
    },
    {
      path: FUNNEL_SIGNUP_MAIN.family,
      name: FUNNEL_SIGNUP_MAIN.family,
      meta: {
        [META_ALLOW_ANONYMOUS]: true,
        [META_PROGRESS]: 3,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.MAIN.FAMILY.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        DataLayerManager.setData(
          { page_type: "formulaire", user_connect: "no", formulaire: "signup", formulaire_step_number: "3" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next();
      },
      component: FamilyStep,
    },
    {
      path: FUNNEL_SIGNUP_MAIN.category,
      name: FUNNEL_SIGNUP_MAIN.category,
      meta: {
        [META_ALLOW_ANONYMOUS]: true,
        [META_PROGRESS]: 3,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.MAIN.CATEGORY.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        DataLayerManager.setData(
          { page_type: "formulaire", user_connect: "no", formulaire: "signup", formulaire_step_number: "3" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next();
      },
      component: CategoryStep,
    },
    {
      path: FUNNEL_SIGNUP_MAIN.check,
      name: FUNNEL_SIGNUP_MAIN.check,
      meta: {
        [META_ALLOW_ANONYMOUS]: true,
        [META_PROGRESS]: 3,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.MAIN.CHECK.@PAGE_TITLE",
      },
      component: CheckStep,
      beforeEnter: (to, from, next) => {
        let nextStep;
        // if we come from identity, jump to the category funnel
        // unless force is specified
        if (from.name === FUNNEL_SIGNUP_MAIN.identity || (from.name === FUNNEL_SIGNUP_MAIN.employees && to.params.force !== true)) {
          nextStep = FUNNEL_SIGNUP_MAIN.category;
        }
        DataLayerManager.setData(
          { page_type: "formulaire", user_connect: "no", formulaire: "signup", formulaire_step_number: "3" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next(nextStep);
      },
    },
    {
      path: FUNNEL_SIGNUP_MAIN.employees,
      name: FUNNEL_SIGNUP_MAIN.employees,
      meta: {
        [META_PROGRESS]: 3,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.INFO.SEATS.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        let nextStep;
        if (from.name === FUNNEL_SIGNUP_MAIN.identity) {
          nextStep = FUNNEL_SIGNUP_MAIN.category;
        }
        DataLayerManager.setData(
          { page_type: "formulaire", formulaire: "signup", formulaire_step_number: "4" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next(nextStep);
      },
      component: EmployeesStep,
    },
    {
      path: FUNNEL_SIGNUP_MAIN.identity,
      name: FUNNEL_SIGNUP_MAIN.identity,
      meta: {
        [META_ALLOW_ANONYMOUS]: true,
        [META_PROGRESS]: 4,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.MAIN.IDENTITY.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        DataLayerManager.setData(
          { page_type: "formulaire", user_connect: "no", formulaire: "signup", formulaire_step_number: "4" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next();
      },
      component: IdentityStep,
    },
    {
      path: FUNNEL_SIGNUP_MAIN.phone,
      name: FUNNEL_SIGNUP_MAIN.phone,
      meta: {
        [META_ALLOW_ANONYMOUS]: true,
        [META_PROGRESS]: 5,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.MAIN.PHONE.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        DataLayerManager.setData(
          { page_type: "formulaire", user_connect: "no", formulaire: "signup", formulaire_step_number: "5" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next();
      },
      component: PhoneStep,
    },
    {
      path: FUNNEL_SIGNUP_MAIN.password,
      name: FUNNEL_SIGNUP_MAIN.password,
      meta: {
        [META_ALLOW_ANONYMOUS]: true,
        [META_PROGRESS]: 6,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.MAIN.PASSWORD.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        DataLayerManager.setData(
          { page_type: "formulaire", user_connect: "no", formulaire: "signup", formulaire_step_number: "6" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next();
      },
      component: PasswordStep,
    },
    {
      path: FUNNEL_SIGNUP_MAIN.origin,
      name: FUNNEL_SIGNUP_MAIN.origin,
      meta: {
        [META_ALLOW_ANONYMOUS]: true,
        [META_PROGRESS]: 7,
        [META_HEADER_TITLE]: "ETAB.PAGES.SIGNUP.STEPS.MAIN.ORIGIN.@PAGE_TITLE",
      },
      beforeEnter: (to, from, next) => {
        DataLayerManager.setData(
          { page_type: "formulaire", user_connect: "no", formulaire: "signup", formulaire_step_number: "7" },
          "etablissement",
          StorageManager.getUserInfo("etablissement"),
        );
        next();
      },
      component: OriginStep,
    },
  ];
};

export const getAccountStepsMeta = () => {
  // only exports the necessary bits to allow for step layout to operate
  return getAccountSteps().map((step) => ({
    path: step.path,
    name: step.name,
    meta: step.meta,
  }));
};
